import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";

export default function AlertModal({
  alertDialogOpen,
  handleCloseAlertDialog,
  cancelBtnName,
  confirmBtnName,
  title,
  desc,
  reInitializationActivity,
  selectedReInitiatedItem,
}) {
  return (
    <Dialog open={alertDialogOpen} onClose={handleCloseAlertDialog}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{desc}</DialogContent>
      <DialogActions>
        <Button onClick={handleCloseAlertDialog} color="primary">
          {cancelBtnName}
        </Button>
        <Button
          onClick={() => reInitializationActivity(selectedReInitiatedItem)}
          color="primary"
        >
          {confirmBtnName}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
